import { ChronicleFilenamesEnum, PlanningModeEnum } from "shared/enums/globalEnums";

import { FcrPlanningEnum, PlanningConfig, SocRestorationPowerKeyEnum, TargetSocTypeEnum } from "../types";

export const planningConfigurations: PlanningConfig[] = [
  {
    name: FcrPlanningEnum.planning_soc_1,
    mode: PlanningModeEnum.soc_management,
    durationInMinutes: 120,
    target_soc_type: TargetSocTypeEnum.soc_trial_1,
    soc_restoration_power_key: null,
    chronicleFilename: null,
    reactivity_delay: 0,
  },
  {
    name: FcrPlanningEnum.planning_trial_1b,
    mode: PlanningModeEnum.fcr_rte_v2_certification,
    durationInMinutes: 250,
    target_soc_type: null,
    soc_restoration_power_key: SocRestorationPowerKeyEnum.soc_restoration_1_3,
    chronicleFilename: ChronicleFilenamesEnum.essai_1bis,
    reactivity_delay: 0,
  },
  {
    name: FcrPlanningEnum.planning_soc_1_2,
    mode: PlanningModeEnum.soc_management,
    durationInMinutes: 50,
    target_soc_type: TargetSocTypeEnum.soc_trial_2_4,
    soc_restoration_power_key: null,
    chronicleFilename: null,
    reactivity_delay: 0,
  },
  {
    name: FcrPlanningEnum.planning_trial_2,
    mode: PlanningModeEnum.fcr_rte_v2_no_reserve,
    durationInMinutes: 40,
    target_soc_type: null,
    soc_restoration_power_key: SocRestorationPowerKeyEnum.soc_restoration_2_4,
    chronicleFilename: ChronicleFilenamesEnum.essai_2v2,
    reactivity_delay: 0,
  },
  {
    name: FcrPlanningEnum.planning_soc_2_3,
    mode: PlanningModeEnum.soc_management,
    durationInMinutes: 50,
    target_soc_type: TargetSocTypeEnum.soc_trial_3,
    soc_restoration_power_key: null,
    chronicleFilename: null,
    reactivity_delay: 0,
  },
  {
    name: FcrPlanningEnum.planning_trial_3,
    mode: PlanningModeEnum.fcr_rte_v2_certification,
    durationInMinutes: 10,
    target_soc_type: null,
    soc_restoration_power_key: SocRestorationPowerKeyEnum.soc_restoration_1_3,
    chronicleFilename: ChronicleFilenamesEnum.essai_3v2,
    reactivity_delay: 0,
  },
  {
    name: FcrPlanningEnum.planning_soc_3_4,
    mode: PlanningModeEnum.soc_management,
    durationInMinutes: 50,
    target_soc_type: TargetSocTypeEnum.soc_trial_2_4,
    soc_restoration_power_key: null,
    chronicleFilename: null,
    reactivity_delay: 0,
  },
  {
    name: FcrPlanningEnum.planning_trial_4,
    mode: PlanningModeEnum.fcr_rte_v2_certification,
    durationInMinutes: 10,
    target_soc_type: null,
    soc_restoration_power_key: SocRestorationPowerKeyEnum.soc_restoration_2_4,
    chronicleFilename: ChronicleFilenamesEnum.essai_4v2,
    reactivity_delay: 0,
  },
  {
    name: FcrPlanningEnum.planning_soc_4_5,
    mode: PlanningModeEnum.soc_management,
    durationInMinutes: 50,
    target_soc_type: TargetSocTypeEnum.notApplicable,
    soc_restoration_power_key: null,
    chronicleFilename: null,
    reactivity_delay: 0,
  },
  {
    name: FcrPlanningEnum.planning_trial_5,
    mode: PlanningModeEnum.fcr_rte_v2_certification,
    durationInMinutes: 5,
    target_soc_type: null,
    soc_restoration_power_key: null,
    chronicleFilename: ChronicleFilenamesEnum.essai_5,
    reactivity_delay: 0,
  },
  {
    name: FcrPlanningEnum.planning_soc_8h,
    mode: PlanningModeEnum.soc_management,
    durationInMinutes: 50,
    target_soc_type: TargetSocTypeEnum.notApplicable,
    soc_restoration_power_key: null,
    chronicleFilename: null,
    reactivity_delay: 0,
  },
  {
    name: FcrPlanningEnum.planning_trial_8h,
    mode: PlanningModeEnum.fcr_rte_v2_certification,
    durationInMinutes: 480,
    target_soc_type: null,
    soc_restoration_power_key: null,
    chronicleFilename: null,
    reactivity_delay: 1500,
  },
];
